import type { FetchModelResponse } from '@cian/http-api';
import type { TCianApiSiteV1GetUserDataByRequestResponse } from '../../../repositories/monolith-python/cian-api/site/v1/get-user-data-by-request';
import type { IFastFiltersUserResponseSchema66 } from '../../../repositories/monolith-python/entities/schemas/FastFiltersUserResponseSchema66';
import { ResponseError } from '../../../utils/errors';

export function assertUnknownError(
  response: TCianApiSiteV1GetUserDataByRequestResponse,
): asserts response is FetchModelResponse<200, 'json', IFastFiltersUserResponseSchema66> {
  if (response.statusCode === 200) {
    return;
  }

  throw new ResponseError({
    domain: 'node/services/user/assert#assertUnknownError()',
    message: 'Unknown error while fetching user data',
  });
}
